import React from 'react';

interface FeatureDetectorProps {
  features?: string[];
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

const DEFAULT_FEATURES = [
  'IntersectionObserver',
  'ResizeObserver',
  'requestAnimationFrame',
  'localStorage',
  'sessionStorage'
];

export const FeatureDetector: React.FC<FeatureDetectorProps> = ({
  features = DEFAULT_FEATURES,
  fallback,
  children
}) => {
  const checkFeatures = (): boolean => {
    try {
      if (typeof window === 'undefined') return true;
      
      const unsupportedFeatures: string[] = [];
      features.forEach(feature => {
        if (!(feature in window)) {
          unsupportedFeatures.push(feature);
        }
      });

      if (unsupportedFeatures.length > 0) {
        console.warn('Unsupported features detected:', unsupportedFeatures);
      }

      return true;
    } catch (error) {
      console.error('Feature detection failed:', error);
      return false;
    }
  };

  const isSupported = checkFeatures();

  if (!isSupported && fallback) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default FeatureDetector;